import _ from "lodash"
import React from "react";
import ProjectEventsTableEmptyRow from "./components/ProjectEventsTableEmptyRow";
import ProjectEventsTableLoadingRow from "./components/ProjectEventsTableLoadingRow";
import ProjectEventsTableRow from "./components/ProjectEventsTableRow";
import StandardTable, { ThemedTableHeaderActionColumn } from "../../components/tables/StandardTable";
import { useClientProjectContext } from "../../hooks/ClientProjectContext";
import { NumericFormat } from "react-number-format";
import { AccordionSection, ThemedIcon, ThemedSpan } from "../../components/utilities";
import { IconButton } from "../../components";
import useProjectEventsList from "./hooks/useProjectEventsList";
import { CreateReminderModal } from "../createreminderform";
import { useClientContext } from "../../hooks/ClientContext";
import EditReminderModal from "../reminders/components/EditReminderModal";
import ViewEventModal from "../vieweeventmodal";
import { FormCheck } from "../../components/forms";

const ClientProjectsEventsTable = ({ label = "Events, Appointments, Phone Calls", onProjectChanged = () => { } }) => {

    const [showCreateEvent, setShowCreateEvent] = React.useState(false);
    const { selectedValue } = useClientProjectContext();
    const { projectId } = selectedValue || { projectId: null };
    const { id : masterAccountId } = useClientContext();
    const [selectedEvent, setSelectedEvent] = React.useState(null);
    const [selectedViewEvent, setSelectedViewEvent] = React.useState(null);

    const { 
        clear,
        data, 
        newRecordsSinceCache, 
        error, 
        isNewRecords, 
        isLoading, 
        isUninitialized, 
        showCancelled, 
        setShowCancelled 
    } = useProjectEventsList(projectId);

    if (!selectedValue) {
        return null;
    }

    return (
        <React.Fragment>
            <CreateReminderModal
                show={showCreateEvent}
                showUserSelect={true}
                masterAccountId={masterAccountId}
                projectId={projectId}
                onHide={() => setShowCreateEvent(null)}
            />
            <EditReminderModal
                show={selectedEvent != null}
                onHide={() => setSelectedEvent(null)}
                reminder={selectedEvent}
            />
            <ViewEventModal 
                show={selectedViewEvent != null}
                handleClose={() => setSelectedViewEvent(null)}
                reminder={selectedViewEvent}
            />
            <AccordionSection label={(
                <div className="d-flex w-100">
                    <div className="flex-fill">{label}</div>
                    {isNewRecords && (
                        <React.Fragment>
                            {newRecordsSinceCache > 1
                                ? (<ThemedSpan variant="danger" className="mx-2"><NumericFormat displayType="text" value={newRecordsSinceCache} thousandSeparator="," /> new records available.</ThemedSpan>)
                                : (<ThemedSpan variant="danger" className="mx-2"><NumericFormat displayType="text" value={newRecordsSinceCache} thousandSeparator="," /> new record available.</ThemedSpan>)
                            }
                            <ThemedIcon variant={isNewRecords ? 'danger' : 'muted'} icon="fas fa-sync" className="has-pointer mx-2" onClick={() => clear()} />)
                        </React.Fragment>
                    )}
                </div>
            )} defaultActiveKey="1">
                {data && data.length > 0 && <span className="pe-2 d-flex justify-content-end">
                    <FormCheck
                        type="checkbox"
                        label="Show Cancelled"
                        isChecked={showCancelled}
                        onChange={() => setShowCancelled(!showCancelled)}
                        disableAnimations
                    />
                </span>}
                <StandardTable 
                    className="table-borderless table-sm"
                    columns={[
                        { label: 'Date', property: 'deadlineDate' },
                        { label: 'Type', property: 'type' },
                        { label: 'Description', property: 'description' },
                        { label: 'Notes', property: 'notes' },
                        { label: 'Created By', property: 'createdBy' },
                        { label: 'Priority', property: 'priority' },
                        { 
                            label: '', 
                            property: '',
                            headerRenderer: (props) => (
                                <ThemedTableHeaderActionColumn key={props.key}>
                                    <IconButton className="btn-sm" icon="fa-plus" variant="success" onClick={() => setShowCreateEvent(_ => true)} />
                                </ThemedTableHeaderActionColumn>
                            )
                        }
                    ]}
                    data={data}
                    error={error}
                    isLoading={isLoading || isUninitialized}
                    isTableResponsive={false}
                    EmptyRowComponent={ProjectEventsTableEmptyRow}
                    emptyRowComponentProps={{ onCreateClicked: () => setShowCreateEvent(_ => true) }}
                    hideHeaderOnEmpty={true}
                    LoadingRowComponent={ProjectEventsTableLoadingRow}
                    RowComponent={ProjectEventsTableRow}
                    rowComponentProps={{ project: selectedValue, setSelectedEvent: setSelectedEvent, setSelectedViewEvent : setSelectedViewEvent }}
                />
            </AccordionSection>
        </React.Fragment>
    )
};

export default ClientProjectsEventsTable;